export default "__VITE_ASSET__7766a351__"